





































































import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
import { mapDeps } from '~/plugins/dependency-container/utils'
import CompareService from '~/services/compare/CompareService'
import SearchService from '~/services/search/SearchService'
import Searchbar from '~/components/shared/classified/search/searchbar/Searchbar.vue'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import { USER_NS } from '~/store/modules/shared/user/state'
import AlternativeSearches from '~/components/car/classifieds/search/results/AlternativeSearches.vue'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import CClassifiedCompareCounter from '~/components/shared/configurable/classified/compare/CClassifiedCompareCounter.vue'
import ViewTypeSelector from '~/components/car/classifieds/search/results/header/ViewTypeSelector.vue'
import Title from '~/components/car/classifieds/search/results/header/Title.vue'
import SortOptions from '~/components/car/classifieds/search/results/header/SortOptions.vue'
import Pagination from '~/components/car/classifieds/search/results/Pagination.vue'
import SelectedHandlers from '~/components/car/classifieds/search/results/header/SelectedHandlers.vue'

export default Vue.extend({
  components: {
    SelectedHandlers,
    Pagination,
    SortOptions,
    Title,
    ViewTypeSelector,
    Searchbar,
    AlternativeSearches,
    CClassifiedCompareCounter,
    MassActions: () =>
      import(
        '~/components/car/classifieds/search/results/mass-actions/MassActions.vue'
      ),
    MassRemoveButton: () =>
      import(
        '~/components/car/classifieds/search/results/header/MassRemoveButton.vue'
      ),
    MassRestoreButton: () =>
      import(
        '~/components/car/classifieds/search/results/header/MassRestoreButton.vue'
      )
  },
  computed: {
    ...mapDeps({
      compareService: CompareService,
      searchService: SearchService
    }),
    ...mapState(CLASSIFIED_SEARCH_NS, {
      alternativeSearches: state => state.alternativeSearches,
      viewType: state => state.viewType,
      title: state => state.title || '',
      shortTitle: state => state.shortTitle,
      longTitle: state => state.longTitle,
      rootCategory: state => state.config.rootParams.category,
      searchBar: state => state.config.settings.searchbar,
      category: state => state.params.category,
      hideViewTypeDesktop: state => state.config.settings.hideViewTypeDesktop,
      allClassifiedsUrl: state => state.allClassifiedsUrl || null,
      isDeletedSearch: state => state.config.settings.isDeletedSearch,
      isCompareButtonVisible: state =>
        state.config.settings.isCompareButtonVisible,
      showSellers: state => state.showSellers
    }),
    ...mapGetters(CLASSIFIED_SEARCH_NS, {
      qHandler: 'getQFacet',
      inDealsSearch: 'inDealsSearch',
      showSellers: 'showSellers',
      showMassActions: 'showMassActions',
      useNewSearchbar: 'useNewSearchbar'
    }),
    ...mapGetters(USER_NS, {
      userIsAdmin: 'isAdmin'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    })
  }
})
